import "./index.scss";
import React, { useState, useEffect, useRef } from "react";
import { format, parseISO, isValid } from 'date-fns';
import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import ThreeDots from "component/ThreeDots";
import api from "api";
import _ from "lodash";
import { useFormik } from 'formik';
import { popinfo } from "component/Fancybox/Fancybox";
import update from 'immutability-helper';
import "quill-mention";
import { AvatarHorizontal1 } from "component/Avatar";
import { QuillBuilder } from "component/RichEditor/RichEditor"

const TalkForm = (props) => {
    const[talkBodyWYSIWYG, setTalkBodyWYSIWYG]         = useState(false);
    const[talk]                                        = useState(props.talk);

    const WYSIWYG = useRef();

    const settingFormValues = (formData) => {
        _.each(formData, (value, attribute) => {
            if(value === null)
            {
                value = '';
            }

            if(attribute == 'TalkBody')
            {
                talkBodyWYSIWYG.setContents(talkBodyWYSIWYG.clipboard.convert(value), 'silent');
            }
            
            formik.setFieldValue(attribute, value);

        });
    }

    const formik = useFormik({
        initialValues: {
            InitiativeID : props.initiative.InitiativeID || 0
            ,TalkBody   : props.talk ? props.talk.TalkBody : ''
            ,TalkParent : props.talk ? props.talk.TalkParent : (props.parent || 0 )
            ,TalkID     : props.talk ? props.talk.TalkID : 0
        }
        ,onSubmit: values => {
            
            let SavingLoader = popinfo('loader', 'Sending Discussion', !props.parent ? 'Send your ideas by discussing with others' : 'Send open ended question to make your dicussion more lively' );

            api('/Talk', 'post', _.assignIn({}, values, {
                TalkBody : talkBodyWYSIWYG.root.innerHTML.replaceAll("\uFEFF", '')
            }) , 'Bearer ' + props.userToken)
                .then(function(response){

                    SavingLoader.close();

                    settingFormValues(props.talk ? response.talk : {
                        TalkBody : ''
                    });

                    props.onSave.apply(null, [response.talk]);

                })
                .catch((error) => {
                    popinfo('error', 'Saving Data', error, {}, SavingLoader);
                });
        }
    });

    useEffect(() => {

        if(talkBodyWYSIWYG === false)
        {
            var rte = QuillBuilder(WYSIWYG.current, props.userToken, {
                mention: {
                    allowedChars : /^[a-zA-Z0-9_]*$/
                    , minChars : 3
                    , mentionDenotationChars : ["@", "#"]
                    , source : function(searchTerm, renderList, mentionChar) {
                        if (searchTerm.length === 0) 
                        {
                            renderList([], searchTerm);
                        }
                        else if (mentionChar === "@" && searchTerm.length > 2) 
                        {
                            api('/Initiative/MentionableUser', 'get', {
                                initiative_id      : props.initiative.InitiativeID
                                ,mention_letter    : searchTerm
                            }, 'Bearer ' + props.userToken)
                                .then((response) => {
                                    renderList(_.map(response.user, (user) => {
                                        return {
                                            id : 'mention-uid-' + user.UserID
                                            ,value : user.UserDisplayName
                                        }
                                    }), searchTerm);
                                })

                        }
                
                    }
                }
            });
    
            rte.once('editor-change', () => {
                setTalkBodyWYSIWYG(rte);
            });
    
            rte.setText('\n', 'silent');
        }

        if(talk && talkBodyWYSIWYG !== false)
        {
            settingFormValues(talk)
        }

    }, [talkBodyWYSIWYG, talk]);

    return (
        <div className="talk-form">
            <div className="wrapper">
                <div className="talk-sender">
                    <AvatarHorizontal1
                        user={props.user}
                    />
                </div>
                <form className="talk-form-body" onSubmit={formik.handleSubmit}>
                    <div id="talk-form-body-editor" ref={WYSIWYG}></div>
                    <div className="text-right mt-md">
                        {
                            (props.talk || props.onCancel) && 
                            <>
                                <button className="btn btn-orange btn-reverse" onClick={(e) => {
                                    e.preventDefault();
                                    
                                    props.onCancel.apply();

                                }}>Cancel</button> &nbsp;
                            </>
                        }
                        <input type="submit" className="btn btn-orange" value={props.talk ? "Save" : "Send"} />
                    </div>
                </form>
            </div>
        </div>
    )

}



const Talk = (props) => {
    console.log('hjhjhj', props);
    const [talk, setTalk]                              = useState(props.talk);
    const [showReplies, setShowReplies]                 = useState(props.autoShowReplies || false);
    const [showRepliesForm, setShowRepliesForm]         = useState(false);
    const [replies, setReplies]                         = useState(false);
    const [fetchingReplies, setFetchingReplies]         = useState(false);
    const [isEditing, setIsEditing]                     = useState(false);

    /**
     * Delete current talks 
     */
    const DeleteTalk = () => {
        let ask = window.confirm('Are You Sure ?');

        if(!ask)
        {
            return;
        }

        let DeleteLoader = popinfo('loader', 'Deleting Discussion', 'Please Wait' );

        api('/Talk', 'delete', {
            talk_id : talk.TalkID
        }, 'Bearer ' + props.userToken)  
            .then((response) => {
                DeleteLoader.close();

                setTalk(response.talk)
            })
            .catch((error) => {
                popinfo('error', 'Deleting Discussion', error, {}, DeleteLoader);
            })
    }

    useEffect(() => {
        if(!showReplies)
        {   
            return;
        }

        if(fetchingReplies)
        {
            return;
        }

        setFetchingReplies(true);

        api('/Talk', 'get', {
            paged               : 1
            ,posts_per_page     : -1
            ,parent_talk_id     : props.talk.TalkID
            ,sort              : 'ASC'
        }, 'Bearer ' + props.userToken)
            .then((response) => {
                setReplies(response.talk);

                setFetchingReplies(false);
                
                if(response.talk.length == 0)
                {
                    setFetchingReplies('EOF');
                }
            });

    }, [showReplies])

    return (
        !isEditing ?
        <div className="component-talk">
            <div className="talk-body">
                <AvatarHorizontal1
                    user={talk}
                    metadata={`${formatDistanceToNow(parseISO(talk.SendDate), 'dd LLLL Y HH:mm:ss')} ago`}
                />
                {
                    !talk.IsDelete && talk.UserID == props.user.UserID &&
                    <ThreeDots>
                        <button onClick={ (e) => {
                            e.preventDefault();
                            
                            setIsEditing(true);
                        }}>Edit</button>
                        <button onClick={ (e) => {
                            e.preventDefault();

                            DeleteTalk();
                        }}>Delete</button>
                    </ThreeDots>
                }
                {
                    talk.IsDelete == 0 &&
                    <>
                        <div className="mt-md talk-content wp-content" dangerouslySetInnerHTML={{__html : talk.TalkBody}}></div>
                        {
                            talk.TalkParent == 0 &&
                            <div className="talk-replies-container">
                                <div className="text-right">
                                    <button className="btn btn-primary btn-small btn-reverse" onClick={(e) => {
                                        e.preventDefault();

                                        setShowReplies(!showReplies);

                                    }}>{ !showReplies ? 'Replies' : 'Close Replies' }</button>
                                </div>
                                {
                                    showReplies && 
                                    <div className="mt-md">
                                        
                                        
                                        <ul className="talk-list">
                                            {
                                                replies !== false && replies.map((reply) => {

                                                    return (
                                                        <li className="talk" key={reply.TalkID}>
                                                            <Talk talk={reply} initiative={props.initiative} user={props.user} userToken={props.userToken} />
                                                        </li>
                                                    )

                                                })
                                            }
                                            {
                                                fetchingReplies === true && 
                                                (
                                                    <li className="talk skeleton-talk mt-md">
                                                        <span className="skeleton"></span>  
                                                    </li>
                                                )
                                            }
                                        </ul>
                                        {
                                            props.talk.TalkParent == 0 && !showRepliesForm &&
                                            <div className="replies-form-introduction rounded bg-white border-solid leading-text text-sm">
                                                give your feedback regarding this discussion
                                                <button className="btn btn-orange btn-small" onClick={(e) => {
                                                    e.preventDefault();

                                                    setShowRepliesForm(true);

                                                }}>Add Reply</button>
                                            </div>
                                        }
                                        {
                                            props.talk.TalkParent == 0 && showRepliesForm && 
                                            <TalkForm
                                                initiative={props.initiative}
                                                userToken={props.userToken}
                                                user={props.user}
                                                parent={talk.TalkID}
                                                onSave={(talk) => {
                                                    setFetchingReplies(false);

                                                    setReplies(update(replies, {
                                                        $unshift : [talk]
                                                    }));
                                                }}
                                                onCancel={() => {
                                                    setShowRepliesForm(false);
                                                }}
                                            />
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </>
                }
                {
                    talk.IsDelete != 0 &&
                    <span className="text-xs font-bold block italic mt-md">Discussion Deleted</span>
                }
            </div>
        </div> : 
        <TalkForm
            initiative={props.initiative}
            userToken={props.userToken}
            user={props.user}
            talk={talk}
            onSave={(talk) => {
                setTalk(talk);

                setIsEditing(false);
            }}
            onCancel={() => {
                setIsEditing(false);
            }}
        />
    )
};

export {Talk, TalkForm};